import AllRoutes from "./routes/AllRoutes";
import "aos/dist/aos.css";
import "./App.css";
import Loading from "./components/DataLoading/DataLoading";
import { useEffect } from "react";
import { useState } from "react";
import { motion } from "framer-motion";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  useEffect(() => {}, []);

  return (
    <div className="w-full relative ">
      {loading ? <Loading /> : <AllRoutes />}
    </div>
  );
}

export default App;
